function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export const CloseCircleLiner24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.3603 8.63965C15.6531 8.93255 15.6531 9.40742 15.3603 9.70031L13.0606 12L15.3603 14.2997C15.6531 14.5925 15.6531 15.0674 15.3603 15.3603C15.0674 15.6532 14.5925 15.6532 14.2996 15.3603L11.9999 13.0606L9.70025 15.3603C9.40736 15.6532 8.93248 15.6532 8.63959 15.3603C8.3467 15.0674 8.3467 14.5925 8.63959 14.2997L10.9393 12L8.63959 9.70031C8.3467 9.40742 8.3467 8.93255 8.63959 8.63965C8.93248 8.34676 9.40736 8.34676 9.70025 8.63965L11.9999 10.9393L14.2996 8.63965C14.5925 8.34676 15.0674 8.34676 15.3603 8.63965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.5 12C23.5 18.3284 18.3284 23.5 12 23.5C5.67157 23.5 0.5 18.3284 0.5 12C0.5 5.67157 5.67157 0.5 12 0.5C18.3284 0.5 23.5 5.67157 23.5 12ZM22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12Z",
  fill: "currentColor"
}));